import { makeStyles } from 'tss-react/mui';
import React, { useEffect } from 'react';
import { CustomBackdrop } from '../../../Common/Backdrop/CustomBackdrop';
import { CustomTabs } from '../../../Common/Tabs/CustomTabs';
import { useTranslation } from 'react-i18next';
import { OrderPreview } from './OrderPreview';
import { orderCreationNewActions } from '@AMIEWEB/NewOrder/Store/OrderCreation.actions';
import { useDispatch, useSelector } from 'react-redux';
import { useInjectReducer } from 'redux-injectors';
import { orderCreationNewReducer, orderCreationNewSliceKey } from '@AMIEWEB/NewOrder/Store/OrderCreation.redux';
import { PreferencesWrapper } from './Preferences/PreferencesWrapper';
import { selectUnitId } from '@AMIEWEB/NewOrder/Store/Order.selectors';
import { useParams } from 'react-router-dom';
import {
  createOrderPreferenceActions,
  createOrderPreferenceReducer,
  createOrderPreferenceSliceKey,
} from 'store/redux-store/create-order-preferences/slice';
import {
  selectCustomTabvalue,
  selectIsUnitPreferenceNull,
  selectUnitInherited,
} from 'store/redux-store/create-order-preferences/selectors';
import { selectUser } from 'oidc/user.selectors';
import { cloneDeep } from 'lodash';

const useStyles = makeStyles()(theme => ({
  root: {
    flexWrap: 'nowrap',
    paddingLeft: '12px',
  },
}));

export const PreviewAndSubmit = props => {
  useInjectReducer({ key: orderCreationNewSliceKey, reducer: orderCreationNewReducer });
  useInjectReducer({ key: createOrderPreferenceSliceKey, reducer: createOrderPreferenceReducer });
  const params = useParams<{ id: string }>();
  const selectedUnitId = useSelector(selectUnitId);
  const unitPreferenceNull = useSelector(selectIsUnitPreferenceNull);
  const customTabvalue = useSelector(selectCustomTabvalue);
  const unitInherited = useSelector(selectUnitInherited);

  const { t } = useTranslation();
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const { userInfo } = useSelector(selectUser);

  const tabs = React.useMemo(
    () => [
      {
        label: `${t('search.globalSearch.order.orderPreview')}`,
        component: <OrderPreview isNewOrderCreation={true} />,
      },
      {
        label: `${t('order.orderDetails.tabs.preferences')}`,
        component: (
          <PreferencesWrapper
            submissionEmailSetup={props.submissionEmailSetup}
            submissionPacketSetup={props.submissionPacketSetup}
          />
        ),
      },
    ],
    [t],
  );

  useEffect(() => {
    return () => {
      if (customTabvalue === undefined) {
        dispatch(createOrderPreferenceActions.setIsFormDirty(true));
      }
      dispatch(createOrderPreferenceActions.setCustomTabValue(undefined));
      dispatch(
        orderCreationNewActions.setPreferencesFormData(cloneDeep({
          ...props.currentprefData,
          updatedBy: userInfo.employeeId,
          orderId: 0,
        })),
      );
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (params?.id && selectedUnitId) {
      dispatch(orderCreationNewActions.getClientContacts({ facilityId: parseInt(params?.id), unitId: selectedUnitId }));
    }
  }, [params?.id, selectedUnitId]);

  const customTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    dispatch(orderCreationNewActions.setPreviewTabSelected(newValue === 1));
    dispatch(
      orderCreationNewActions.setPreferencesFormData(cloneDeep({
        ...props.currentprefData,
        updatedBy: userInfo.employeeId,
        orderId: 0,
      })),
    );

    const unitDialoge = {
      dialogeOpen: true,
      dialogeItem: 'preference',
    };
    if (!unitPreferenceNull && newValue === 1 && !unitInherited) {
      dispatch(createOrderPreferenceActions.setUnitDialoge(unitDialoge));
      dispatch(createOrderPreferenceActions.setTabValue(newValue));
      dispatch(createOrderPreferenceActions.setCustomTabValue(undefined));
    } else {
      dispatch(createOrderPreferenceActions.setCustomTabValue(newValue));
    }
  };

  return (
    <div className={classes.root}>
      <CustomBackdrop open={false} />
      <CustomTabs tabs={tabs} dense customValue={customTabvalue} customHandleChange={customTabChange} />
    </div>
  );
};
